import { X } from "react-feather"

const MapMonterDiv = ({ item, clearMonter }) => {
    return (
        <div className="w-full max-w-lg mx-auto">
            <div className="py-2 px-4 flex gap-2 items-center shadow-lg border rounded-xl border-neutral-500 dark:border-neutral-800 bg-color-2 fg-color-1">
                <span className="bg-primary-500 px-1 rounded text-white">
                    {item.monternummer}
                </span>
                <span className="flex-1 line-clamp-1 text-ellipsis">
                    {item.organisation_namn}
                </span>
                <button className="text-red-400">
                    <X size={24} onClick={clearMonter} />
                </button>
            </div>
        </div>
    )
}

export default MapMonterDiv
